import API_MAP from "../../constants/api";
import axiosClient, { axiosFullResponse } from "../axiosClient";

class ApiManagerSubtitles {
    // getListSub = ({startDate = '', endDate = '', rooName = '', isMy = '', isShareWithMy = '', isTrash = ''}) => {
    //     return axiosClient.get(API_MAP.GET_LIST_SUB + `?start_time_search=${startDate}&end_time_search=${endDate}&room_name=${rooName}&is_my=${isMy}&is_share_with_me=${isShareWithMy}&is_moved_to_trash=${isTrash}`)
    // }
    getListSub= async ({startDate, endDate , ...restQuery }) => {
		var url = `?start_time_search=${startDate}&end_time_search=${endDate}`;
		if (restQuery) {
			for (let [query, value] of Object.entries(restQuery)) {
					url = url + `&${query}=${value}`;
			}
		}
		return axiosClient.get(API_MAP.GET_LIST_SUB + url);
	}
	lockOrUnlockSub = (data) => {
		return axiosClient.post(API_MAP.LOCK_OR_UNLOCK, data)
	}
	moveOrNotMoveToTrash = (data) => {
		return axiosClient.post(API_MAP.MOVE_TO_TRASH_SUB, data)
	}
	deleteForever = (data) => {
		return axiosClient.post(API_MAP.DELETE_FOREVER_SUB, data)
	}
	deleteAllForever = (data = {}) => {
		return axiosClient.post(API_MAP.DELETE_ALL_FOREVER_SUB, data)
	}
	getListSharedPeopleById = (id) => {
		return axiosClient.get(API_MAP.GET_SHARED_LIST_PEOPLE_BY_ID + '?live_captions_id='+ id)
	}
	sharePeopleLiveCaptions = (data) => {
		return axiosClient.post(API_MAP.SHARE_PEOPLE_LIVE_CAPTIONS, data)
	}
	unsharePeopleLiveCaptions = (data) => {
		return axiosClient.post(API_MAP.UNSHARE_PEOPLE_LIVE_CAPTIONS, data)
	}
	viewDetailSub = (id) => {
		return axiosClient.get(API_MAP.VIEW_DETAIL_SUB + '?liveCaptionsId=' + id)
	}
	exportFileSub = (id, type) => {
		return axiosFullResponse.get(API_MAP.EXPORT_FILE_SUB + type + "?liveCaptionsId=" + id, {responseType: 'blob'})
	}
	exportFileSummary = (id) => {
		return axiosFullResponse.get(API_MAP.EXPORT_FILE_SUMMARY + "?liveCaptionsId=" + id, {responseType: 'blob'})
	}
	getJoinedParticipants = (roomId, currentPage = 0, perpage = 100, isModerator = 1) => {
        return axiosClient.get(API_MAP.ROOM_API.GET_DETAIL_STATISTICS_ROOM + '?roomId=' + roomId + "&page=" + currentPage + "&perPage="+ perpage + "&isModerator=" + isModerator);
    }
	updateSummarySub = (id, detailText, generalText) => {
		return axiosClient.post(API_MAP.UPDATE_SUMMARY_SUB, {
			livecaption_id: id,
			detail_text: detailText,
			general_text: generalText
		})
	}
	
}

const apiManagerSubtitles = new ApiManagerSubtitles();


export default apiManagerSubtitles;